import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "reply-text"
};
const _hoisted_2 = {
  key: 0,
  class: "keyword-content min-h-12 mt-4"
};
const _hoisted_3 = {
  key: 0,
  class: "key-word mt-3"
};
const _hoisted_4 = {
  class: "left-box flex-1 overflow-hidden"
};
const _hoisted_5 = {
  class: "right-box flex-1 overflow-hidden"
};
const _hoisted_6 = {
  key: 1,
  class: "footer-block mt-6"
};
import { computed, ref, watch, nextTick } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import MenuBlock from '@components/MenuBlock.vue';
import useMainStore from '../../main.store';
import AnimateText from '../AnimateText.vue';
import ConfirmWord from './components/ConfirmWord.vue';
import PreviewText from './components/PreviewText.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'KeywordVerification',
  props: {
    item: {},
    content: {}
  },
  setup(__props) {
    const props = __props;
    const AnimateTextRef = ref();
    const activeIns = ref(0);
    const show = ref(true);
    const loading = ref(false);
    const checkedWordFiles = ref([]);
    const activeItem = ref({});
    const info = computed(() => {
      if (props.content) {
        try {
          return props.content;
        } catch {
          return {
            knowledgeDetails: []
          };
        }
      }
      return {
        knowledgeDetails: []
      };
    });
    const tabList = computed(() => {
      const list = [];
      info.value.knowledgeDetails.forEach((item, ins) => {
        list.push({
          label: item.keyword,
          value: ins
        });
      });
      return list;
    });
    const showActiveList = computed(() => {
      const list = [[], []];
      const arr = info.value?.knowledgeDetails[activeIns.value]?.attachmentDetails || [];
      arr.forEach((item, ins) => {
        list[ins % 2].push(item);
      });
      return list;
    });
    const mainStore = useMainStore();
    const disabled = computed(() => {
      return mainStore.lastMsgId !== props.item.id;
    });
    function getChooseWordAndFile() {
      const wordAndFile = [];
      info.value.knowledgeDetails.forEach(item => {
        const {
          keyword,
          keywordId
        } = item;
        const attachmentDetails = [];
        item.attachmentDetails.forEach(file => {
          if (checkedWordFiles.value.some(son => son.knowledgeId === file.knowledgeId)) {
            attachmentDetails.push(file);
          }
        });
        if (attachmentDetails.length > 0) {
          wordAndFile.push({
            keyword,
            attachmentDetails,
            keywordId
          });
        }
      });
      return wordAndFile;
    }
    async function handleSure() {
      if (!checkedWordFiles.value.length) {
        ElMessage.warning('请选择关键词知识库');
        return;
      }
      await ElMessageBox.confirm('我确认已仔细审核上述资料，并授权系统将其用于AI知识库构建和全网GEO内容策略执行。我理解此操作不可撤销。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });
      const wordAndFile = getChooseWordAndFile();
      mainStore.handleKeywordSure(wordAndFile);
    }
    async function handleCancel() {
      await ElMessageBox.confirm(`<p>您即将驳回本次AI智能分析结果，驳回后将重新生成分析，建议您：</p>
    <p class="inset-3">1. 先补充完善AI提示词资料</p>
    <p class="inset-3">2. 检查公司资料完整性</p>
    <p >是否确认驳回并重新分析?</p>`, '提示', {
        customClass: 'keyword-verify-confirm',
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      });
      mainStore.handleKeywordSure(info.value.knowledgeDetails, 2).catch(() => {
        props.item.openAnimate = true;
      });
    }
    function handleEnd() {
      show.value = true;
      loading.value = true;
      setTimeout(() => {
        loading.value = false;
        mainStore.loadNextMsg(props.item);
      }, 2000);
    }
    function handleClickFull(item) {
      activeItem.value = item;
    }
    function handleWordFileClick(file) {
      if (checkedWordFiles.value.some(item => item.knowledgeId === file.knowledgeId)) {
        checkedWordFiles.value = checkedWordFiles.value.filter(item => item.knowledgeId !== file.knowledgeId);
      } else {
        handleClickFull(file);
        checkedWordFiles.value.push(file);
      }
    }
    function hanTabChange() {
      activeItem.value = {};
      // const [item] = info.value.knowledgeDetails[activeIns.value].attachmentDetails
      // handleClickFull(item)
    }
    // watch(
    //   () => info.value.knowledgeDetails.length,
    //   len => {
    //     if (len > 0) {
    //       const [item] = info.value.knowledgeDetails[activeIns.value].attachmentDetails
    //       handleClickFull(item)
    //     }
    //   },
    //   { immediate: true },
    // )
    watch(() => props.item.openAnimate, async newVal => {
      if (newVal) {
        show.value = false;
        await nextTick();
        AnimateTextRef.value?.typeWriter(info.value.tips || '');
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["user-upload", {
          disabled: disabled.value
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(AnimateText, {
        ref_key: "AnimateTextRef",
        ref: AnimateTextRef,
        text: __props.item.openAnimate ? '' : info.value.tips,
        onEnd: handleEnd
      }, null, 8, ["text"])]), show.value ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(MenuBlock, {
        modelValue: activeIns.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeIns.value = $event),
        list: tabList.value,
        onChange: hanTabChange
      }, null, 8, ["modelValue", "list"]), !loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showActiveList.value[0], son => {
        return _openBlock(), _createBlock(ConfirmWord, {
          key: son.knowledgeId,
          disabled: disabled.value,
          name: son.fileName,
          checked: checkedWordFiles.value.some(item => item.knowledgeId === son.knowledgeId),
          active: son.filePath && activeItem.value.filePath === son.filePath,
          onClick: $event => handleWordFileClick(son),
          onClickFull: $event => handleClickFull(son)
        }, null, 8, ["disabled", "name", "checked", "active", "onClick", "onClickFull"]);
      }), 128))]), _createVNode(PreviewText, {
        title: activeItem.value.fileName,
        "text-url": activeItem.value.filePath
      }, null, 8, ["title", "text-url"]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showActiveList.value[1], son => {
        return _openBlock(), _createBlock(ConfirmWord, {
          key: son.knowledgeId,
          disabled: disabled.value,
          name: son.fileName,
          checked: checkedWordFiles.value.some(item => item.knowledgeId === son.knowledgeId),
          active: son.filePath && activeItem.value.filePath === son.filePath,
          onClick: $event => handleWordFileClick(son),
          onClickFull: $event => handleClickFull(son)
        }, null, 8, ["disabled", "name", "checked", "active", "onClick", "onClickFull"]);
      }), 128))])])) : _createCommentVNode("", true)])), [[_directive_loading, loading.value]]) : _createCommentVNode("", true), show.value && !loading.value && !disabled.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_button, {
        type: "primary",
        class: "w-[89px]",
        onClick: handleSure
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("确认知识库", -1)]))]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "text",
        class: "cancel-btn",
        onClick: handleCancel
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("对分析结果不满意？", -1)]))]),
        _: 1
      })])) : _createCommentVNode("", true), _cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "footer-tip"
      }, " 您确认的资料将被用于AI模型处理并在全网进行GEO内容策略执行。此授权操作一旦确认将无法撤销，请谨慎确认。 ", -1))], 2);
    };
  }
});